import { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import { goToBackPageTransformer } from "../../utils";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";



const UsersPage =  () => {

    const [users, setUsers] = useState(null)
    const [laoding, setLaoding] = useState(null)
    const [error, setError] = useState(null)
    const [search, SetSearch] = useState('')
    const {findUser} = useContext(AdminContext)
    const navigate = useNavigate();
    const location = useLocation();
    const goBack = () => {
        // console.log(window.history);
        // console.log(location.pathname)
        if (window.history.length > 3) {
          navigate(-1); // Переход на предыдущую страницу в истории
        } else {
          // console.log(location)
          navigate(goToBackPageTransformer(2, location.pathname)) 
        }
      };
    


    const searchInputHandler = (el) => {
        
        SetSearch((el.target.value).trim())
    }

    const searchHandler = () => {
     
        setUsers(null)
        setError(null)
        if(search.length < 3)
        {
            setError('Введите 3 и более символов')
        } else 
        {   
            setLaoding(true)
            findUser(search).then(res => {
                if(res.data.length > 0)
                {
                    setUsers(res.data)
                }
                else 
                {
                    setError('Пользователь не найден')
                }
            }).finally(()=> {setLaoding(false)})
        }
        
    }

    useEffect(()=> {document.title = 'Пользователи'}, [])
    return (
        <div className="container">
    <div className="admin__users">
        
        <ButtonBack shortBtn={true}/>
        <div className="search">
            <label htmlFor="search__input">Поиск по фамилии, имени</label>
           <div className="search__form">
            <input className="search__input" placeholder="Поиск" onInput={searchInputHandler} value={search} />
            <button className="search__btn" onClick={searchHandler} disabled={(laoding && 'disabled') || (search.length <= 2 && "disabled")}>Найти</button> 
          
           </div> 
            {laoding && 
            <div style={{position:'relative', minHeight: 120}}><CoveredBackground><Loader/></CoveredBackground></div>
             }
            <div className="search__items" >

            {error ? <ErrorMessage message={error}/> : 
                users && 
                users.map(user => (
                <div className="search__item" key={user.id} title={`ИИН: ${user.iin}`}>
                    <Link className="search__question"  to={`/admin/users/${user.id}`} >
                        {user.name} {!user.admin && user.surname} 
                    </Link>
                </div>
                ))
            }   
           
        
               
            </div>
        </div>
    </div>
</div>
    )
}


export default UsersPage